import { Injectable } from '@angular/core';
import {BackendService} from "./backend.service";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {ResponseDto} from "../dto/response.dto";

@Injectable({
  providedIn: 'root'
})
export class CityService {

  private urlPrefix = '/api/city';

  constructor(private backend: BackendService) {}

  getDepartmentCityList(departmentCode: string): Observable<any> {
    const url = `${this.urlPrefix}/list/department/${departmentCode}`;
    return this.backend.get(url).pipe(
        map((response: ResponseDto) => response.response)
    );
  }
}
